<template>
    <transition name="chat-slide">
        <div class="chat-panel" v-if="state.isPanelOpen">
            <div class="chat-panel-header">
                <template v-if="activeRoom">
                    <a href="#" class="chat-header-btn" @click.prevent="ChatManager.closeRoom()" title="Wróć do listy">
                        <i class="material-icons md-18">arrow_back</i>
                    </a>
                    <div class="chat-panel-title">
                        {{ ChatManager.getRoomDisplayName(activeRoom) }}
                        <small v-if="activeRoom.type == 'group'" class="chat-members-count">({{ activeRoom.members.length }})</small>
                    </div>
                    <a href="#" class="chat-header-btn" v-if="activeRoom.type == 'group'" @click.prevent="openInvite" title="Uczestnicy / zaproś">
                        <i class="material-icons md-18">group_add</i>
                    </a>
                    <a href="#" class="chat-header-btn" v-if="activeRoom.type == 'group'" @click.prevent="leaveRoom" title="Opuść pokój">
                        <i class="material-icons md-18">logout</i>
                    </a>
                </template>
                <template v-else>
                    <div class="chat-panel-title"><i class="material-icons md-18 m-r-xs">forum</i> Chat firmowy</div>
                </template>
                <a href="#" class="chat-header-btn" @click.prevent="ChatManager.closePanel()" title="Zamknij">
                    <i class="material-icons md-18">close</i>
                </a>
            </div>

            <template v-if="activeRoom">
                <ChatMessageList :room="activeRoom" class="chat-panel-body"/>
                <ChatMessageInput :room="activeRoom"/>
            </template>
            <ChatRoomList v-else class="chat-panel-body"/>
        </div>
    </transition>
</template>

<script>
import Api from '../../Api.js';
import ChatManager from '../../ChatManager.js';
import ChatRoomList from './ChatRoomList.vue';
import ChatMessageList from './ChatMessageList.vue';
import ChatMessageInput from './ChatMessageInput.vue';
import ChatInviteModal from './ChatInviteModal.vue';

export default {
    name: 'ChatPanel',
    components: { ChatRoomList, ChatMessageList, ChatMessageInput },
    data: function() {
        return {
            ChatManager,
            state: ChatManager.state,
        };
    },
    computed: {
        activeRoom: function() {
            if (!this.state.activeRoomId) return null;
            return this.state.rooms.find(r => String(r._id) == String(this.state.activeRoomId)) || null;
        }
    },
    methods: {
        openInvite: function() {
            this.$modal.show(ChatInviteModal, { room: this.activeRoom }, {
                draggable: false,
                clickToClose: true,
                height: 'auto',
                width: '400px'
            });
        },
        leaveRoom: async function() {
            const ok = await this.$h.confirm('Czy na pewno chcesz opuścić pokój "' + this.activeRoom.name + '"?');
            if (!ok) return;
            try {
                await this.leave(this.activeRoom._id);
            } catch (e) {
                this.$h.commonApiError(e);
            }
        },
        leave: async function(roomId) {
            await Api.chat.removeMember(roomId, ChatManager.getMyUserId());
            const idx = this.state.rooms.findIndex(r => String(r._id) == String(roomId));
            if (idx != -1) this.state.rooms.splice(idx, 1);
            ChatManager.closeRoom();
        }
    }
};
</script>

<style scoped lang="scss">
.chat-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 380px;
    max-width: 100vw;
    z-index: 11500; /* poniżej warstwy modali (12000) */
    display: flex;
    flex-direction: column;
    background: var(--dm-surface, #fff);
    color: var(--dm-text, #333);
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.18);
}

.chat-slide-enter-active, .chat-slide-leave-active {
    transition: transform 0.25s ease;
}
.chat-slide-enter, .chat-slide-leave-to {
    transform: translateX(100%);
}

.chat-panel-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 12px 14px;
    border-bottom: 1px solid var(--dm-border, #e9ecef);
    flex-shrink: 0;
}

.chat-panel-title {
    flex: 1;
    font-weight: 600;
    font-size: 15px;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.chat-members-count {
    margin-left: 6px;
    font-weight: 400;
    opacity: 0.7;
}

.chat-header-btn {
    color: inherit;
    opacity: 0.7;
    display: flex;
    align-items: center;
}
.chat-header-btn:hover { opacity: 1; }

.chat-panel-body {
    flex: 1;
    overflow-y: auto;
}
</style>
